import { Box, Stack, Typography } from "@mui/material";
import List from "@mui/material/List";
import FileListItem from "@poseidon/ui/components/FileListItem/FileListItem";
import Switch from "@poseidon/ui/components/Switch";
import React, { useState } from "react";

export function PreviouslyUploadedFiles({
  files,
  resolveMetadata,
  readonly,
  showMetadata,
}) {
  const [showFileMetadata, setShowFileMetadata] = useState(
    showMetadata ?? true
  );
  const showMetaDataSwitch = typeof showMetadata === "undefined";
  return (
    <Stack>
      {files?.length > 0 && (
        <>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Stack direction="row" alignItems="center">
              <Typography variant="subtitile">
                Previously uploaded files
              </Typography>
            </Stack>
            {showMetaDataSwitch && (
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="caption">Display File Metadata</Typography>
                <Switch
                  checked={showFileMetadata}
                  onClick={() => setShowFileMetadata(!showFileMetadata)}
                />
              </Stack>
            )}
          </Box>
          <List dense={true}>
            {files.map((file) => (
              <FileListItem
                key={file.id}
                file={file}
                resolveMetadata={resolveMetadata}
                showFileMetadata={showFileMetadata}
                readonly={readonly}
              />
            ))}
          </List>
        </>
      )}
    </Stack>
  );
}
